module.exports = __webpack_public_path__ + "static/img/card_03.bf436781.jpg";